// Libs
import classNames from 'classnames/bind';
import { Box, Chip } from '@mui/material';
// Components, Layouts, Pages
// Others
import { formatTitleCase } from '~/utils/helper/common';
import { ChipColorEnum, StatusEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './BaseStatus.module.scss';

type Props = {
  label: string;
};

const cx = classNames.bind(styles);

const BaseStatus = (props: Props) => {
  //#region Destructuring Props
  const { label } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const getColor = () => {
    switch (label) {
      case StatusEnum.ACTIVE:
      case StatusEnum.IN_PROGRESS:
      case StatusEnum.PAID:
      case StatusEnum.WON:
      case StatusEnum.ACCEPTED:
        return ChipColorEnum.SUCCESS;
      case StatusEnum.INACTIVE:
      case StatusEnum.DELAY:
      case StatusEnum.AWAITING_APPROVAL:
        return ChipColorEnum.WARNING;
      case StatusEnum.REJECTED:
      case StatusEnum.CANCELED:
      case StatusEnum.LOST:
      case StatusEnum.UN_PAID:
      case StatusEnum.NO_GO:
        return ChipColorEnum.ERROR;
      case StatusEnum.RECALL:
      case StatusEnum.J_O_H:
        return ChipColorEnum.WARNING;
      case StatusEnum.J_I_P:
        return ChipColorEnum.SUCCESS;
      case StatusEnum.COMPLETED:
      case StatusEnum.OPEN:
      case StatusEnum.SCHEDULED:
        return ChipColorEnum.INFO;
      case StatusEnum.NOT_STARTED:
      case StatusEnum.UNSCHEDULED:
        return ChipColorEnum.PRIMARY;
      case StatusEnum.CONVERT_TO_JOB:
        return ChipColorEnum.SECONDARY;
      default:
        return ChipColorEnum.DEFAULT;
    }
  };
  //#endregion Handle Function

  return (
    <Chip
      classes={{
        root: cx('chip'),
        colorDefault: cx('backgroundDefault'),
        colorSuccess: cx('backgroundSuccess'),
        colorWarning: cx('backgroundWarning'),
        colorError: cx('backgroundError'),
        colorInfo: cx('backgroundInfo'),
        colorPrimary: cx('backgroundPrimary'),
        colorSecondary: cx('backgroundSecondary'),
        outlined: cx('outlined'),
      }}
      variant='outlined'
      color={getColor()}
      {...(getColor() !== ChipColorEnum.DEFAULT && { avatar: <Box className={cx('dot', getColor())} /> })}
      label={formatTitleCase(label)}
    />
  );
};

export default BaseStatus;
